/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useSelector } from 'react-redux';
import useTabCommandPipeline from 'modules/common/ui-controller/hooks/use-tab-command-pipeline';
import { selectResetBookingDate, selectTabList } from 'modules/dashboard/selectors';
import SUMMARY_COMMAND_STEPS from './summary-command-steps';

/**
 * Custom hook to execute summary tab filter command flow, see SUMMARY_COMMAND_STEPS for the order
 * @param {Number} tabValue - summary tab value
 * @param {Object} filters - filter panel state the commands read: isLoaded, customBooking, paceList,
 * chartBreakdownList, dateComparison, organization, hotelList, hotelGroupList, isHotelForecast,
 * handleComparisonChange, handleToggleChange
 */
const useSummaryCommandPipeline = (tabValue, filters) => {
  const TAB_VALUE = useSelector(selectTabList);
  const resetBookingDate = useSelector(selectResetBookingDate);
  //
  useTabCommandPipeline(SUMMARY_COMMAND_STEPS, { ...filters, resetBookingDate }, tabValue, [
    TAB_VALUE.SUMMARY,
  ]);
};

export default useSummaryCommandPipeline;
